
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1b9047d53d9f9d22': `2) Premi Condividi nella barra di navigazione`,
's37a9e8aec5713460': `Più`,
's5c6aad7a7e4a1437': `3) Premi Aggiungi alla schermata principale`,
's6196153c4b0c1ea0': `Installa`,
's8d0173763d91830c': `Questo sito dispone di funzionalità dell'app. Aggiungila alla tua schermata principale per un'esperienza completa e un facile accesso.`,
'sa5ef80b4bb9b39f8': `Meno`,
'sc79fd7641eb9a975': `Nascondi istruzioni`,
'scdaf4bbff76674c8': `Aggiungi alla schermata principale`,
'sdca23702207fba73': `Questo sito dispone di funzionalità dell'app. Installala sul tuo dispositivo per un'esperienza completa e un facile accesso.`,
'sdfe23506a3b0cdc8': `1) Apri nel browser Safari`,
    };
  